import styled, { css } from 'styled-components';

export const SwipeGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.8;
  }

  select {
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #d5dbe7;
    font-size: 13px;
    background: #f9fbff;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.blue700};
      box-shadow: 0 0 0 2px rgba(76, 139, 245, 0.15);
    }
  }
`;

export const DirectionSelector = styled.div`
  display: flex;
  gap: 8px;
`;

interface DirectionButtonProps {
  active?: boolean;
}

export const DirectionButton = styled.button<DirectionButtonProps>`
  ${({ active, theme }) => css`
    flex: 1;
    padding: 8px 0;
    border-radius: 8px;
    border: 1px solid #d5dbe7;
    background: ${active ? theme.colors.blue700 : '#f4f6fb'};
    color: ${active ? '#fff' : '#333'};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${active ? theme.colors.blue700 : '#e8f0ff'};
      border-color: ${theme.colors.blue700};
    }
  `}
`;

